export default class JsonMapperModuleResolver {
  static getResolvedModule() {
    return null;
  }
}